import { useSelector } from 'react-redux';
import { commonSelectors } from '@lialo/core/lib/pages/common';

export function useShouldShowFollowButton(authorId: string) {
  const userId = useSelector(commonSelectors.selectUser)?.id;

  const isMe = userId === authorId;
  return !isMe;
}
